(function () {
  'use strict';

  var PRODUCT_COD = '.es-popup-button-product';
  var EASYSELL_STICKY = '#es-sticky.es-sticky-product';
  var DRAWER_COD = '.es-popup-button-drawer';
  var CART_COD = '.es-popup-button-drawer, .es-popup-button-cart';
  var ONLINE_CHECKOUT = '#CartDrawer-Checkout, button[name="checkout"], a[href^="/checkout"]';
  var PRODUCT_ADD = 'button[name="add"]';
  var SAFE_PRODUCT_CLASS = 'wealtivo-safe-product-cod';
  var SAFE_STICKY_ID = 'wealtivo-safe-sticky-cod';
  var SAFE_STICKY_WRAP_ID = 'wealtivo-safe-sticky-purchase';
  var refreshQueued = false;
  var bundleReadyAt = 0;
  var replayingNativeAdd = false;
  var nativeAddReplayTimer = 0;
  var nativeAddReplayExpiresAt = 0;
  var nativeAddIntent = 'cod';

  function isVisible(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }

  function drawerIsOpen() {
    return Boolean(document.querySelector('cart-drawer.active, cart-drawer[open], #CartDrawer.active, #CartDrawer[open]'));
  }

  function cartIsEmpty() {
    var drawer = document.querySelector('cart-drawer');
    return Boolean(drawer && drawer.classList.contains('is-empty'));
  }

  function codModalIsOpen() {
    var modal = document.querySelector('.es-modal-content, .es-popup-modal, [class*="es-modal"]');
    return isVisible(modal);
  }

  function arrangeDrawerPaymentButtons() {
    document.querySelectorAll(CART_COD).forEach(function (codButton) {
      var empty = cartIsEmpty();
      codButton.hidden = empty;
      codButton.setAttribute('aria-hidden', empty ? 'true' : 'false');
      if (empty) {
        codButton.setAttribute('tabindex', '-1');
        codButton.classList.remove('wealtivo-cod-secondary');
        return;
      }

      var holder = codButton.parentElement;
      if (!holder) return;

      var onlineButton = holder.querySelector(ONLINE_CHECKOUT);
      if (onlineButton && codButton.previousElementSibling !== onlineButton) {
        holder.insertBefore(onlineButton, codButton);
      }

      if (onlineButton) {
        onlineButton.classList.add('wealtivo-online-primary');
        var onlineText = onlineButton.querySelector('.wt-cart-checkout__text');
        var onlineBadge = onlineButton.querySelector('.wt-card-badge');
        var onlineLabel = onlineButton.querySelector('.button__label');

        if (onlineText) {
          if (onlineText.textContent.trim() !== 'Kartla Güvenli') onlineText.textContent = 'Kartla Güvenli';
          if (onlineBadge && onlineBadge.textContent.trim() !== 'Öde') onlineBadge.textContent = 'Öde';
        } else if (onlineLabel) {
          if (onlineLabel.textContent.trim() !== 'Kartla Güvenli Öde') onlineLabel.textContent = 'Kartla Güvenli Öde';
        } else if (onlineButton.textContent.trim() !== 'Kartla Güvenli Öde') {
          onlineButton.textContent = 'Kartla Güvenli Öde';
        }

        onlineButton.setAttribute('aria-label', 'Kartla güvenli online ödemeye geç');
        onlineButton.setAttribute('title', 'Önerilen ödeme yöntemi');
      }

      codButton.classList.add('wealtivo-cod-secondary');
      var codTitle = codButton.querySelector('.es-button-title');
      if (codTitle) {
        if (codTitle.textContent.trim() !== 'Kapıda Ödeme') codTitle.textContent = 'Kapıda Ödeme';
        codTitle.style.setProperty('color', '#111', 'important');
      } else if (codButton.textContent.trim() !== 'Kapıda Ödeme') {
        codButton.textContent = 'Kapıda Ödeme';
      }
      codButton.setAttribute('aria-label', 'Kapıda ödeme formunu aç');
      codButton.setAttribute('role', 'button');
      codButton.setAttribute('tabindex', '0');
      codButton.style.setProperty('background', '#fff', 'important');
      codButton.style.setProperty('border-color', '#111', 'important');
      codButton.style.setProperty('border-style', 'solid', 'important');
      codButton.style.setProperty('border-width', '1.5px', 'important');
      codButton.style.setProperty('color', '#111', 'important');
      if (!codButton.dataset.wealtivoKeyboardReady) {
        codButton.dataset.wealtivoKeyboardReady = 'true';
        codButton.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            codButton.click();
          }
        });
      }
    });
  }

  function replaceExactText(root, from, to) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim() === from) {
        node.nodeValue = node.nodeValue.replace(from, to);
      }
    }
  }

  function formatTryAmount(rawAmount) {
    var source = String(rawAmount || '').replace(/\s+/g, '');
    var integerPart = source;
    var decimalPart = '';
    var lastComma = source.lastIndexOf(',');
    var lastDot = source.lastIndexOf('.');

    if (lastComma >= 0 && lastDot >= 0) {
      if (lastDot > lastComma) {
        decimalPart = source.slice(lastDot + 1);
        integerPart = source.slice(0, lastDot).replace(/,/g, '');
      } else {
        decimalPart = source.slice(lastComma + 1);
        integerPart = source.slice(0, lastComma).replace(/\./g, '');
      }
    } else if (lastComma >= 0) {
      var commaTail = source.slice(lastComma + 1);
      if (commaTail.length === 2) {
        decimalPart = commaTail;
        integerPart = source.slice(0, lastComma).replace(/,/g, '');
      } else {
        integerPart = source.replace(/,/g, '');
      }
    } else if (lastDot >= 0) {
      var dotTail = source.slice(lastDot + 1);
      if (dotTail.length === 2) {
        decimalPart = dotTail;
        integerPart = source.slice(0, lastDot).replace(/\./g, '');
      } else {
        integerPart = source.replace(/\./g, '');
      }
    }

    integerPart = integerPart.replace(/\D/g, '') || '0';
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (decimalPart === '00') decimalPart = '';
    return integerPart + (decimalPart ? ',' + decimalPart : '') + ' TL';
  }

  function formatTryText(value) {
    return String(value || '').replace(/(\d[\d.,]*\d|\d)\s*TL\b/g, function (_match, rawAmount) {
      return formatTryAmount(rawAmount);
    });
  }

  function normalizeTryText(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var formatted = formatTryText(node.nodeValue);
      if (formatted !== node.nodeValue) node.nodeValue = formatted;
    }
  }

  function normalizeVisibleMoney() {
    document.querySelectorAll('cart-drawer, #easysell-modal, kaching-bundles-block, .price').forEach(function (root) {
      normalizeTryText(root);
    });
  }

  function localizeJudgeMe() {
    document.querySelectorAll('.jdgm-sort-dropdown-label').forEach(function (label) {
      if (label.textContent.trim() === 'Sort by') label.textContent = 'Sırala';
    });
  }

  function localizeCart() {
    var drawer = document.querySelector('cart-drawer, #CartDrawer');
    if (!drawer) return;

    var heading = Array.prototype.find.call(drawer.querySelectorAll('h1,h2,h3'), function (item) {
      return /Sepetdeki|Sepetinizde/.test(item.textContent);
    });
    if (heading) {
      var countMatch = heading.textContent.match(/(\d+)/);
      var count = countMatch ? countMatch[1] : '0';
      var expected = 'Sepetinizde · ' + count + ' ürün';
      if (heading.textContent.trim() !== expected) heading.textContent = expected;
    }

    replaceExactText(drawer, 'İNDİRİM SONA ERİYOR', 'Kampanyanın bitmesine');
    var giftText = drawer.querySelector('.cart-progress__text');
    if (giftText && /Hediyyelerin/.test(giftText.textContent)) {
      giftText.textContent = 'Ücretsiz kargo avantajınız hazır.';
    }
  }

  function prepareCodModal() {
    var modal = document.querySelector('#easysell-modal');
    if (!modal) return;

    var form = modal.querySelector('#es-form');
    if (!form) return;

    var header = form.querySelector('.es-form-header');
    if (header && !form.querySelector('.wealtivo-payment-method-banner')) {
      var banner = document.createElement('div');
      banner.className = 'wealtivo-payment-method-banner';
      banner.textContent = 'Ödeme yöntemi: Kapıda ödeme';
      header.insertAdjacentElement('afterend', banner);
    }

    var title = form.querySelector('.es-header-group strong');
    if (title && title.textContent.trim() !== 'Sipariş bilgilerinizi girin.') {
      title.textContent = 'Sipariş bilgilerinizi girin.';
    }

    var close = form.querySelector('.close-icon');
    if (close) {
      close.setAttribute('role', 'button');
      close.setAttribute('tabindex', '0');
      close.setAttribute('aria-label', 'Kapıda ödeme formunu kapat');
      if (!close.dataset.wealtivoKeyboardReady) {
        close.dataset.wealtivoKeyboardReady = 'true';
        close.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            close.click();
          }
        });
      }
    }

    var cta = form.querySelector('.es-cta-btn');
    if (cta) {
      var amountMatch = form.innerText.match(/Toplam\s+([0-9.,]+\s*TL)/i) || cta.textContent.trim().match(/([0-9.,]+\s*TL)\s*$/i);
      var amount = amountMatch ? formatTryText(amountMatch[1]) : '';
      if (amount) {
        var expected = 'Kapıda Ödeme Siparişini Onayla · ' + amount;
        if (cta.textContent.trim() !== expected) cta.textContent = expected;
      }

    }

    replaceExactText(form, 'Email', 'E-posta');
    replaceExactText(form, 'All taxes included', 'Vergiler dahildir.');
    replaceExactText(form, 'Buyer accepts marketing', 'Pazarlama izni');

    var emailInput = form.querySelector('input[type="email"], input[name*="email" i]');
    if (emailInput && emailInput.getAttribute('placeholder') !== 'E-posta') {
      emailInput.setAttribute('placeholder', 'E-posta');
    }

    var marketingCheckbox = form.querySelector('input[type="checkbox"]');
    if (marketingCheckbox && !marketingCheckbox.dataset.wealtivoConsentInitialized) {
      marketingCheckbox.dataset.wealtivoConsentInitialized = 'true';
      if (marketingCheckbox.checked) {
        marketingCheckbox.checked = false;
        marketingCheckbox.removeAttribute('checked');
        marketingCheckbox.dispatchEvent(new Event('input', { bubbles: true }));
        marketingCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function mainNativeAdd() {
    var exact = document.querySelector('product-form[data-main="true"] button[name="add"].main-product-atc');
    if (exact && !exact.disabled && isVisible(exact)) return exact;
    return null;
  }

  function markDrawerCod() {
    var codButton = document.querySelector(DRAWER_COD);
    if (!codButton) return;
    codButton.classList.remove('wealtivo-cod-ready');
    window.requestAnimationFrame(function () {
      codButton.classList.add('wealtivo-cod-ready');
      window.setTimeout(function () {
        codButton.classList.remove('wealtivo-cod-ready');
      }, 1600);
    });
  }

  function markDrawerOnline() {
    var onlineButton = document.querySelector(ONLINE_CHECKOUT);
    if (!onlineButton) return;
    onlineButton.classList.remove('wealtivo-cod-ready');
    window.requestAnimationFrame(function () {
      onlineButton.classList.add('wealtivo-cod-ready');
      window.setTimeout(function () {
        onlineButton.classList.remove('wealtivo-cod-ready');
      }, 1600);
    });
  }

  function markDrawerIntent() {
    if (nativeAddIntent === 'online') {
      markDrawerOnline();
    } else {
      markDrawerCod();
    }
    nativeAddIntent = 'cod';
  }

  function waitForDrawer() {
    var startedAt = Date.now();
    var timer = window.setInterval(function () {
      arrangeDrawerPaymentButtons();
      if (drawerIsOpen()) {
        window.clearInterval(timer);
        markDrawerIntent();
        updateSafeSticky();
      } else if (Date.now() - startedAt > 4500) {
        window.clearInterval(timer);
      }
    }, 100);
  }

  function scheduleNativeAddReplay(delay) {
    if (nativeAddReplayTimer) window.clearTimeout(nativeAddReplayTimer);
    nativeAddReplayTimer = window.setTimeout(attemptNativeAddReplay, Math.max(0, delay));
  }

  function cancelNativeAddReplay() {
    if (nativeAddReplayTimer) window.clearTimeout(nativeAddReplayTimer);
    nativeAddReplayTimer = 0;
    nativeAddReplayExpiresAt = 0;
  }

  function attemptNativeAddReplay() {
    nativeAddReplayTimer = 0;
    var now = Date.now();

    if (now < bundleReadyAt) {
      nativeAddReplayExpiresAt = Math.max(nativeAddReplayExpiresAt, bundleReadyAt + 5000);
      scheduleNativeAddReplay(bundleReadyAt - now);
      return;
    }

    var nativeAdd = mainNativeAdd();
    if (!nativeAdd) {
      if (now < nativeAddReplayExpiresAt) {
        scheduleNativeAddReplay(100);
      } else {
        nativeAddReplayExpiresAt = 0;
      }
      return;
    }

    nativeAddReplayExpiresAt = 0;
    replayingNativeAdd = true;
    try {
      nativeAdd.click();
    } finally {
      replayingNativeAdd = false;
    }
    waitForDrawer();
  }

  function queueNativeAddReplay(intent) {
    nativeAddIntent = intent === 'online' ? 'online' : 'cod';
    var now = Date.now();
    nativeAddReplayExpiresAt = Math.max(nativeAddReplayExpiresAt, Math.max(now, bundleReadyAt) + 5000);
    scheduleNativeAddReplay(bundleReadyAt - now);
  }

  function safeProductToCart(event) {
    event.preventDefault();
    event.stopPropagation();
    var originalButton = event.currentTarget && event.currentTarget.id === SAFE_STICKY_ID
      ? document.querySelector(EASYSELL_STICKY)
      : document.querySelector(PRODUCT_COD);
    if (!originalButton) originalButton = document.querySelector(PRODUCT_COD + ', ' + EASYSELL_STICKY);
    if (originalButton) originalButton.click();
  }

  function markBundleSelectionPending(event) {
    if (!event.target || !event.target.closest) return;
    var option = event.target.closest(
      'kaching-bundles-block .kaching-bundles__bar-main, quantity-breaks input[name="quantity"], quantity-breaks label'
    );
    if (option) {
      bundleReadyAt = Date.now() + 1300;
      if (nativeAddReplayTimer) {
        nativeAddReplayExpiresAt = Math.max(nativeAddReplayExpiresAt, bundleReadyAt + 5000);
        scheduleNativeAddReplay(bundleReadyAt - Date.now());
      }
    }
  }

  function guardFastNativeAdd(event) {
    if (replayingNativeAdd) return;
    if (Date.now() >= bundleReadyAt) {
      cancelNativeAddReplay();
      return;
    }
    if (!event.target || !event.target.closest) return;

    var nativeAdd = event.target.closest(
      'product-form[data-main="true"] button[name="add"].main-product-atc'
    );
    if (!nativeAdd) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    queueNativeAddReplay('online');
  }

  function createSafeProductButton(originalButton) {
    var next = originalButton.nextElementSibling;
    if (next && next.classList.contains(SAFE_PRODUCT_CLASS)) return next;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = SAFE_PRODUCT_CLASS + ' wealtivo-safe-cod';
    button.textContent = 'Kapıda Ödemeye Devam Et';
    button.setAttribute('aria-label', 'Seçili paket için kapıda ödeme formunu aç');
    button.addEventListener('click', safeProductToCart, true);
    originalButton.insertAdjacentElement('afterend', button);
    return button;
  }

  function prepareProductButtons() {
    document.querySelectorAll(PRODUCT_COD).forEach(function (originalButton) {
      originalButton.setAttribute('aria-hidden', 'true');
      originalButton.setAttribute('tabindex', '-1');
      createSafeProductButton(originalButton);
    });
  }

  function createSafeSticky() {
    var wrapper = document.getElementById(SAFE_STICKY_WRAP_ID);
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.id = SAFE_STICKY_WRAP_ID;
      wrapper.className = 'wealtivo-safe-sticky-purchase';
      wrapper.setAttribute('aria-hidden', 'true');
      document.body.appendChild(wrapper);
    }

    var codButton = document.getElementById(SAFE_STICKY_ID);
    if (!codButton) {
      codButton = document.createElement('button');
      codButton.id = SAFE_STICKY_ID;
      codButton.type = 'button';
      codButton.className = 'wealtivo-safe-cod wealtivo-safe-cod--sticky';
      codButton.textContent = 'Şimdi Sipariş Ver - Kapıda Ödeme';
      codButton.setAttribute('aria-label', 'Kapıda ödeme sipariş formunu aç');
      codButton.setAttribute('tabindex', '-1');
      codButton.addEventListener('click', safeProductToCart, true);
      wrapper.appendChild(codButton);
    }

    return wrapper;
  }

  function updateSafeSticky() {
    var sticky = document.getElementById(SAFE_STICKY_WRAP_ID);
    if (!sticky) return;

    var productButton = document.querySelector('.' + SAFE_PRODUCT_CLASS);
    var buyAreaPassed = productButton && productButton.getBoundingClientRect().bottom < 0;
    var shouldShow = buyAreaPassed && !drawerIsOpen() && !codModalIsOpen();
    sticky.classList.toggle('is-visible', Boolean(shouldShow));
    sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    sticky.querySelectorAll('button').forEach(function (button) {
      button.setAttribute('tabindex', shouldShow ? '0' : '-1');
    });
  }

  function prepareEasySellSticky() {
    document.querySelectorAll(EASYSELL_STICKY).forEach(function (originalSticky) {
      originalSticky.setAttribute('aria-hidden', 'true');
      originalSticky.setAttribute('tabindex', '-1');
    });
    createSafeSticky();
    updateSafeSticky();
  }


  function arrangeNoseGiftPriority() {
    if (window.location.pathname.replace(/\/$/, '') !== '/products/miknatisli-burun-bandi') return;

    document.querySelectorAll('.kaching-bundles__bar-container').forEach(function (bar) {
      const gifts = Array.from(bar.querySelectorAll('.kaching-bundles__free-gift'));
      const refillGift = gifts.find(function (gift) {
        return (gift.textContent || '').toLocaleLowerCase('tr-TR').includes('yedek bant');
      });
      const eyeGift = gifts.find(function (gift) {
        const text = (gift.textContent || '').toLocaleLowerCase('tr-TR');
        return text.includes('göz bandı') || text.includes('uyku maskesi');
      });

      if (
        refillGift &&
        eyeGift &&
        refillGift.parentElement === eyeGift.parentElement &&
        refillGift.nextElementSibling !== eyeGift
      ) {
        eyeGift.parentElement.insertBefore(refillGift, eyeGift);
      }
    });
  }

  function refresh() {
    refreshQueued = false;
    prepareProductButtons();
    prepareEasySellSticky();
    arrangeDrawerPaymentButtons();
    localizeCart();
    prepareCodModal();
    normalizeVisibleMoney();
    arrangeNoseGiftPriority();
    localizeJudgeMe();
    updateSafeSticky();
  }

  function scheduleRefresh() {
    if (refreshQueued) return;
    refreshQueued = true;
    window.requestAnimationFrame(refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }

  new MutationObserver(scheduleRefresh).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.addEventListener('scroll', updateSafeSticky, { passive: true });
  window.addEventListener('resize', updateSafeSticky, { passive: true });
  document.addEventListener('click', markBundleSelectionPending, true);
  document.addEventListener('change', markBundleSelectionPending, true);
  document.addEventListener('click', guardFastNativeAdd, true);
  document.addEventListener('click', function (event) {
    if (event.target.closest('.drawer__close, #easysell-modal .close-icon')) {
      window.setTimeout(updateSafeSticky, 180);
    }
  }, true);
})();
